// Imports
import Button from "@mui/material/Button";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconCloudDownload from "@material-ui/icons/CloudDownload";
// UI Imports
// import { DatePicker } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
// App Imports
import params from "../../../setup/config/params";
import { list as listCategory } from "../../category/api/actions/query";
import { messageShow } from "../../common/api/actions";
import Section from "../../common/Section";
import SectionPaper from "../../common/SectionPaper";
import { list as listPincodes } from "../../pincode/api/actions/query";
import {
  barChartCalculation,
  pieChartCalculation,
  productReportStockCollection,
  reportOrderCollection,
  reportOrderPrepaidDeliveriesToday,
  customerWalletReport,
  productPurchaseReport,
} from "../api/actions/query";
import { settingDetail } from "../../setting/api/actions/query";
// import BarChart from '../Charts/BarChart'
// import PieChart from '../Charts/PieChart'
import styles from "./styles";

// ---- Latest UI Library imports
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { checkPermission } from "../../common/Sidebar/checkPermission";
// Component
class Reports extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      startDateForWallet: new Date(),
      endDateForWallet: new Date(),
      startDateForPurchase: new Date(),
      endDateForPurchase: new Date(),
      pincodeId: "all",
      categoryId: "all",
      paymentType: "all",
      channel: "all",
      pieData: [],
      barData: [],
      paymentConfiguration: [],  
      permissions: {
        canView: false,
        canEdit: false,
        canCreate: false,
        canDelete: false,
      },
    };
  }

  componentDidMount() {
    const { listPincodes, listCategory } = this.props;

    listPincodes();
    listCategory();
    this.pieChartLoad();
    this.barChartLoad();
    this.fetchSettings();
    this.verifyPermissions();
  }

  verifyPermissions = async () => {
    const permission = await checkPermission("analytics", "reports");
    this.setState({ permissions: permission });
  };

  fetchSettings = async () => {
    const { settingDetail } = this.props;
    try {
      const { data } = await settingDetail();
      if (data.success && data.data) {
        this.setState({ 
          paymentConfiguration: data.data.paymentConfiguration || []
         });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };

  barChartLoad = async () => {
    const { barChartCalculation } = this.props;
    const { startDate, endDate, pincodeId, paymentType } = this.state;

    try {
      const { data } = await barChartCalculation({
        startDate,
        endDate,
        pincodeId,
        paymentType,
      });

      if (data.success) {
        this.setState({
          barData: data.data,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  pieChartLoad = async () => {
    const { pieChartCalculation } = this.props;
    const { startDate, endDate, pincodeId, paymentType } = this.state;

    try {
      const { data } = await pieChartCalculation({
        startDate,
        endDate,
        pincodeId,
        paymentType,
      });
      if (data.success) {
        this.setState({
          pieData: data,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  handleDateChange = (date) => (value) => {
    this.setState({
      [date]: new Date(value),
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onOrderCollectionStatement = async () => {
    const { reportOrderCollection, messageShow } = this.props;
    const { startDate, endDate, pincodeId, paymentType, channel } = this.state;
    try {
      const { data } = await reportOrderCollection({
        startDate,
        endDate,
        pincodeId,
        paymentType,
        channel,
      });
      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    } catch (e) {
      messageShow("There was some error. Please try again.");
    }
  };

  onStockReportStatement = async () => {
    const { productReportStockCollection, messageShow } = this.props;
    const { categoryId } = this.state;
    try {
      const { data } = await productReportStockCollection({
        categoryId,
      });

      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    } catch (e) {
      messageShow("There was some error. Please try again.");
    }
  };

  onWalletReportStatement = async () => {
    const { customerWalletReport, messageShow } = this.props;
    const { startDateForWallet, endDateForWallet } = this.state;

    try {
      const { data } = await customerWalletReport({
        startDate: startDateForWallet,
        endDate: endDateForWallet,
      });

      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    } catch (e) {
      messageShow("There was some error. Please try again.");
    }
  };

  onPurchaseReportStatement = async () => {
    const { productPurchaseReport, messageShow } = this.props;
    const { startDateForPurchase, endDateForPurchase } = this.state;

    try {
      const { data } = await productPurchaseReport({
        startDate: startDateForPurchase,
        endDate: endDateForPurchase,
      });

      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    } catch (e) {
      messageShow("There was some error. Please try again.");
    }
  };

  onOrderPrepaidDeliveriesToday = async () => {
    const { reportOrderPrepaidDeliveriesToday, messageShow } = this.props;
    const { pincodeId } = this.state;

    try {
      const { data } = await reportOrderPrepaidDeliveriesToday({ pincodeId });

      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    } catch (e) {
      messageShow("There was some error. Please try again.");
    }
  };

  render() {
    const { pincodes, categories, classes } = this.props;
    const {
      startDate,
      endDate,
      pincodeId,
      categoryId,
      paymentType,
      channel,
      paymentConfiguration,
      permissions,
    } = this.state;
    return (
      <div>
        {/* Header */}
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Reports
          </Typography>
        </Toolbar>

        {/* Filter */}
        <SectionPaper padding>
          <Grid container spacing={10}>
            {/* Date start */}
            <Grid item>
              <DatePicker
                label="Start Date"
                value={dayjs(startDate)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("startDate")}
                disabled={!permissions.canView}
              />
            </Grid>
            {/* Date end */}
            <Grid item>
              <DatePicker
                label="End Date"
                value={dayjs(endDate)}
                slotProps={{ textField: { variant: "standard" } }}
                minDate={dayjs(startDate)}
                onChange={this.handleDateChange("endDate")}
                disabled={!permissions.canView}
              />
            </Grid>

            {/* Pincode */}
            <Grid item>
              <FormControl style={{ minWidth: 150 }} disabled={!permissions.canView}>
                <InputLabel shrink htmlFor="pincode">
                  Pincode
                </InputLabel>
                <Select
                  value={pincodeId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: "pincodeId",
                    id: "pincode",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {pincodes.list.map((pincode) => (
                    <MenuItem key={pincode._id} value={pincode._id}>
                      {pincode.pincode}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Payment Mode */}
            <Grid item>
              <FormControl style={{ minWidth: 150 }} disabled={!permissions.canView}>
                <InputLabel shrink htmlFor="paymentType">
                  Payment Mode
                </InputLabel>
                <Select
                  value={paymentType}
                  onChange={this.handleChange}
                  inputProps={{
                    name: "paymentType",
                    id: "paymentType",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value={params.payment.types.cod.key}> {params.payment.types.cod.title}</MenuItem>
                  {params.payment.types.pas && (
                    <MenuItem value={params.payment.types.pas.key}> {params.payment.types.pas.title}</MenuItem>
                  )}
                  <MenuItem value={params.payment.types.online.key}> {params.payment.types.online.title}</MenuItem> 
                  {paymentConfiguration.filter((config) => config.isEnabled).map((config) => {
                    if (config.name === "STRIPE") {
                      return (
                       <MenuItem key="Stripe" value={params.payment.types.Stripe.key}>
                          {params.payment.types.Stripe.title}
                       </MenuItem>
                      );
                    }
                   if (config.name === "SQUARE_PAY") {
                      return (
                        <MenuItem key="Square" value={params.payment.types.Square.key}>
                          {params.payment.types.Square.title}
                        </MenuItem>
                      );
                    }
                    if (config.name === "RAZOR_PAY") {
                      return (
                        <MenuItem key="Razor" value={params.payment.types.Razor.key}>
                          {params.payment.types.Razor.title}
                        </MenuItem>
                      );
                    }
                    return null;
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item>
              <FormControl style={{ minWidth: 150 }} disabled={!permissions.canView}>
                <InputLabel shrink htmlFor="channel">
                  Channel
                </InputLabel>
                <Select
                  value={channel || "all"}
                  onChange={this.handleChange}
                  inputProps={{
                    name: "channel",
                    id: "channel",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="mobile">Mobile</MenuItem>
                  <MenuItem value="web">Web</MenuItem>
                  <MenuItem value="instore">Instore</MenuItem>
              </Select>
              </FormControl>
            </Grid>
          </Grid>
          {/* Download buttons */}
          <Section style={{ padding: 0, paddingTop: 38 }}>
            <Grid container direction={"row"} spacing={2}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onOrderCollectionStatement}
                  disabled={!permissions.canView}
                >
                  <IconCloudDownload style={{ marginRight: 10 }} />
                  Order Collection Statement
                </Button>
              </Grid>
              {/* <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onOrderPrepaidDeliveriesToday}
                >
                  <IconCloudDownload style={{ marginRight: 10 }} />
                  Deliveries for Today
                </Button>
              </Grid> */}
            </Grid>
          </Section>
        </SectionPaper>

        <SectionPaper padding>
          <Grid container spacing={10}>
            {/* Date start */}
            {/* <Grid item>
              <DatePicker
                label="Start Date"
                value={dayjs(startDateStock)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("startDateStock")}
              />
            </Grid> */}

            {/* Date end */}
            {/* <Grid item>
              <DatePicker
                label="End Date"
                value={dayjs(endDateStock)}
                minDate={dayjs(startDateStock)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("endDateStock")}
              />
            </Grid> */}

            {/* Category */}
            <Grid item>
              <FormControl style={{ minWidth: 150 }} disabled={!permissions.canView} >
                <InputLabel shrink htmlFor="category">
                  Category
                </InputLabel>
                <Select
                  value={categoryId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: "categoryId",
                    id: "category",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {categories.list.map((category) =>
                    category.subCategories.map((subCategory) => (
                    <MenuItem
                      key={subCategory._id}
                      value={subCategory._id}
                    >
                      {subCategory.name}
                    </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {/* Download buttons */}
          <Section style={{ padding: 0, paddingTop: 38 }}>
            <Grid container spacing={10}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onStockReportStatement}
                  disabled={!permissions.canView}
                >
                  <IconCloudDownload style={{ marginRight: 10 }} />
                  Stock Report
                </Button>
              </Grid>
            </Grid>
          </Section>
        </SectionPaper>

        {/* <SectionPaper padding>
          <Grid container spacing={10}>
            <Grid item>
              <DatePicker
                label="Start Date"
                value={dayjs(startDateForWallet)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("startDateForWallet")}
              />
            </Grid>

            <Grid item>
              <DatePicker
                label="End Date"
                value={dayjs(endDateForWallet)}
                minDate={dayjs(startDateForWallet)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("endDateForWallet")}
              />
            </Grid>
          </Grid>
          <Section style={{ padding: 0, paddingTop: 38 }}>
            <Grid container spacing={10}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onWalletReportStatement}
                >
                  <IconCloudDownload style={{ marginRight: 10 }} />
                  Customer Wallet Report
                </Button>
              </Grid>
            </Grid>
          </Section>
        </SectionPaper> */}

        {/* <SectionPaper padding>
          <Grid container spacing={10}>
            <Grid item>
              <DatePicker
                label="Start Date"
                value={dayjs(startDateForPurchase)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("startDateForPurchase")}
              />
            </Grid>

            <Grid item>
              <DatePicker
                label="End Date"
                value={dayjs(endDateForPurchase)}
                minDate={dayjs(startDateForPurchase)}
                slotProps={{ textField: { variant: "standard" } }}
                onChange={this.handleDateChange("endDateForPurchase")}
              />
            </Grid>
          </Grid>
          <Section style={{ padding: 0, paddingTop: 38 }}>
            <Grid container spacing={10}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.onPurchaseReportStatement}
                >
                  <IconCloudDownload style={{ marginRight: 10 }} />
                  Product Purchase Report
                </Button>
              </Grid>
            </Grid>
          </Section>
        </SectionPaper> */}

        {/* <Grid container jstify="space-around">
          <Grid item xs={6}>
            <PieChart pincodes={pincodes.list} pieData={pieData} />
          </Grid>
          <Grid item xs={6}>
            <BarChart barData={barData} />
          </Grid>
        </Grid> */}
      </div>
    );
  }
}

// Component Properties
Reports.propTypes = {
  pincodes: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  listPincodes: PropTypes.func.isRequired,
  listCategory: PropTypes.func.isRequired,
  reportOrderCollection: PropTypes.func.isRequired,
  productReportStockCollection: PropTypes.func.isRequired,
  customerWalletReport: PropTypes.func.isRequired,
  productPurchaseReport: PropTypes.func.isRequired,
  pieChartCalculation: PropTypes.func.isRequired,
  barChartCalculation: PropTypes.func.isRequired,
  reportOrderPrepaidDeliveriesToday: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  settingDetail: PropTypes.func.isRequired
};

// Component State
function reportsState(state) {
  return {
    pincodes: state.pincodes,
    categories: state.categories,
  };
}

export default connect(reportsState, {
  listPincodes,
  listCategory,
  reportOrderCollection,
  productReportStockCollection,
  reportOrderPrepaidDeliveriesToday,
  pieChartCalculation,
  barChartCalculation,
  messageShow,
  customerWalletReport,
  productPurchaseReport,
  settingDetail,
})(withStyles(styles)(Reports));
